var _ = require("lodash");
import moment from "moment";


/** Recive data and trans */
export const dataFormat = {
    data() {
        return {
            // Strava API units
            apiVelUnit: 'm/s',
            apiDistanceUnit: 'm',
            apiTimeUnit: 's',

            // App default units
            usrVelUnit: 'km/h',
            usrDistanceUnit: 'km',
            usrTimeUnit: 'h',

            // App default masks
            usrDateMask: 'DD/MM/YYYY',
            usrNumberMask: '0.0'
        };
    },
    methods: {
        velToUsr(value, unit) {
            if (!unit) {
                unit = this.usrVelUnit;
            }
            if (unit == 'km/h') {
                return `${this.numberToUsr(value * 3.6)} km/h`;
            }
            return null;
        },
        distanceToUsr(value, unit = this.usrDistanceUnit) {
            if (unit == 'km') {
                return `${this.numberToUsr(value / 1000)} km`;
            }
            return null;
        },
        dateToUsr(value, mask) {
            if (!mask) {
                mask = this.usrDateMask;
            }
            return moment(new Date(value)).format(mask);
        },
       
        getRange(dist, binSize) {
            if(isNaN(binSize)){
                binSize = 3;
            }
            
            let distanceSpans = [];
            

            for (var i = 0; i < 500; i += binSize) {
                distanceSpans.push(`${i}-${i + binSize}`)
            }

            return distanceSpans.find((e) => {
                let s = e.split("-");
                return dist >= s[0] && dist < s[1];
            });
        },
        sum(numbers) {
            return _.reduce(numbers, (a, b) => a + b, 0);
        },
        average(numbers) {
            return this.sum(numbers) / (numbers.length || 1);
        },
        make_window(before, after) {
            return function (_number, index, array) {
                const start = Math.max(0, index - before);
                const end = Math.min(array.length, index + after + 1);
                return _.slice(array, start, end);
            };
        },
        window(_number, index, array) {
            const start = Math.max(0, index - 3);
            const end = Math.min(array.length, index + 3);
            return _.slice(array, start, end);
        },
        moving_average(before, after, numbers) {
            return _.chain(numbers)
                .map(this.make_window(before, after))
                .map(this.average)
                .value();
        },
    }
}